"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALE_LIST = exports.LOCALE_CURRENCY_DEFAULTS = exports.DROPDOWN_VALUES = exports.DROPDOWN_POSITIONS = exports.CURRENCY_LIST = void 0;
var CURRENCY_LIST = [{
  shortform: 'AUD',
  shortSymbol: '',
  longform: 'Australian Dollar'
}, {
  shortform: 'CNY',
  shortSymbol: '¥',
  longform: 'Chinese Renminbi Yuan'
}, {
  shortform: 'EUR',
  shortSymbol: '€',
  longform: 'Euro'
}, {
  shortform: 'GBP',
  shortSymbol: '£',
  longform: 'British Pound'
}, {
  shortform: 'HKD',
  shortSymbol: 'HK$',
  longform: 'Hong Kong Dollar'
}, {
  shortform: 'JPY',
  shortSymbol: '¥',
  longform: 'Japanese Yen'
}, {
  shortform: 'MYR',
  shortSymbol: 'RM',
  longform: 'Malaysia Ringgit'
}, {
  shortform: 'NZD',
  shortSymbol: '₹',
  longform: 'New Zealand Dollar'
}, {
  shortform: 'PHP',
  shortSymbol: '₱',
  longform: 'Philippines Peso'
}, {
  shortform: 'SGD',
  shortSymbol: 'S$',
  longform: 'Singapore Dollar'
}, {
  shortform: 'THB',
  shortSymbol: '฿',
  longform: 'Thailand Baht'
}, {
  shortform: 'USD',
  shortSymbol: '$',
  longform: 'US Dollar'
}, {
  shortform: 'BDT',
  shortSymbol: '৳',
  longform: 'Bangladesh Taka'
}, {
  shortform: 'BND',
  shortSymbol: '',
  longform: 'Brunei Dollar'
}, {
  shortform: 'INR',
  shortSymbol: '₹',
  longform: 'Indian Rupee'
}, {
  shortform: 'IDR',
  shortSymbol: 'Rp',
  longform: 'Indonesia Rupiah'
}, {
  shortform: 'KRW',
  shortSymbol: '₩',
  longform: 'South Korean Won'
}, {
  shortform: 'MOP',
  shortSymbol: '',
  longform: 'Macau Pataca'
}, {
  shortform: 'TWD',
  shortSymbol: 'NT$',
  longform: 'Taiwanese NT Dollar'
}, {
  shortform: 'VND',
  shortSymbol: '₫',
  longform: 'Vietnamese Dong'
}];
exports.CURRENCY_LIST = CURRENCY_LIST;
var LOCALE_LIST = [{
  shortform: 'En',
  longform: 'English',
  default: 'en-gb'
}, {
  shortform: 'TH',
  longform: 'ภาษาไทย',
  default: 'th-th'
}, {
  shortform: 'ID',
  longform: 'Bahasa Indonesia',
  default: 'id-id'
}, {
  shortform: 'ZH',
  longform: '简体中文',
  default: 'zh-cn'
}, {
  shortform: 'ZH',
  longform: '繁體中文',
  default: 'zh-tw'
}, {
  shortform: 'ZH',
  longform: '繁體中文 (香港)',
  default: 'zh-hk'
}, {
  shortform: 'JA',
  longform: '日本語',
  default: 'ja-jp'
}, {
  shortform: 'KO',
  longform: '한국어',
  default: 'ko-kr'
}, {
  shortform: 'MS',
  longform: 'Bahasa Malaysia',
  default: 'ms-my'
}, {
  shortform: 'VI',
  longform: 'Tiếng Việt',
  default: 'vi-vn'
}, {
  shortform: 'TR',
  longform: 'Turkish',
  default: 'tr-tr'
}];
exports.LOCALE_LIST = LOCALE_LIST;
var DROPDOWN_VALUES = {
  LOCALE: 'Language',
  CURRENCY: 'Currency'
};
exports.DROPDOWN_VALUES = DROPDOWN_VALUES;
var DROPDOWN_POSITIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};
exports.DROPDOWN_POSITIONS = DROPDOWN_POSITIONS;
var LOCALE_CURRENCY_DEFAULTS = {
  LOCALE: 'en-gb',
  CURRENCY: 'USD',
  LOCALE_OBJ: {
    shortform: 'En',
    longform: 'English',
    default: 'en-gb'
  },
  CURRENCY_OBJ: {
    shortform: 'USD',
    shortSymbol: '$',
    longform: 'US Dollar'
  },
  LABEL_CONFIG: {
    POP_LANG: 'Popular languages',
    OTHER_LANG: 'Other supported languages',
    LANG: 'Supported languages',
    POP_CURR: 'Suggested currency',
    OTHER_CURR: 'Other supported currency',
    CURR: 'Supported currency'
  },
  POSITION: DROPDOWN_POSITIONS.LEFT,
  ICONS: {
    HEADER: 'LanguageIcon',
    CURRENCY: 'MonetizationOnIcon',
    LOCALE: 'PublicIcon'
  }
};
exports.LOCALE_CURRENCY_DEFAULTS = LOCALE_CURRENCY_DEFAULTS;